/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/require-default-props */
import styled from 'styled-components';
import { useEffect, useState } from 'react';
import PeopleCardLarge, { PersonProps } from 'Components/common/components/PeopleCardLarge';
// import BuyerColumn from 'Components/people/components/BuyerColumn';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { actions } from 'Slice/BuyerGroupsPageSlice';
import {
  selectApplicationCategory,
  selectBuyerTooltip,
  selectBuyersCategory,
  selectChampionsCategory,
  selectDecisionMakerCategory,
  selectDragPersonPersonality,
  selectEconomicCategory,
  selectInfrastructureCategory,
  selectMemberCategories,
  selectMemberCategoryLoading,
  selectMembers,
  // selectMembersEnded,
  selectMembersInitialLoading, selectMembersLoading, selectMembersPageNumber,
  selectNonTechnicalLeadersCategory,
  selectPeopleRemovedFlag,
  selectPureStorageFlag,
  selectSecurityCategory,
  selectTechnicalCategory,
  selectTechnicalLeadersCategory,
} from 'Selector/BuyerGroupSelector';
// import { getSkeletonsForGroups, getSkeletonsForPeopleOfGroups, PeopleNotFound } from 'Pages/people/PeopleGroupDetail';
import {
  backgroundColorParsing,
  camelCaseToNormal,

  //  IsMobile
} from 'Utils/UtilityFunctions';
// import InfiniteScroll from 'react-infinite-scroll-component';
import {
  CategoryStages, ChangeCategoryData, MemberCategories, TopPeople,
} from 'Types/BuyerGroupsPageTypes';
import DragWrapper from 'Components/people/components/DragWrapper';
import { usePrevious } from 'Utils/hooks/usePrevious';
// import DropWrapper from 'Components/people/components/DropWrapper';
// import { selectGroupTitleName } from 'Selector/UISelector';
import {
  boxShadow,
  greyColor,
  greyColorSecondary,
  maxMobile,
  maxTablet,
  maxWidth,
  midWidthApp,
  minExtraLargeScreen,
  minStandardScreen,
  minWidthApp,
  nutenixColor,
  primaryColor,
  primaryFont, primaryHeadingColor, retina, white, wMBold,
  wMedium,
} from 'Utils/utilsStyle';
import { Popover } from 'antd';
import { Executive } from 'Types/PersonTypes';
import InfiniteScroll from 'react-infinite-scroll-component';
import PersonSkeleton from 'Components/common/skeleton/PersonSkeleton';
import { selectGroupCategory } from 'Selector/UISelector';
import { selectDisclessPersonality } from 'Selector/GlobalSearchContentSelector';
import classNames from 'classnames';
import CollapseIcon from '../assets/icons/CollapseIcon';
import GridHeadingBox from './GridHeadingBox';
import GridContentBox from './GridContentBox';
import ExpandIcon from '../assets/icons/ExpandIcon';

const Wrapper = styled.div<{ isExpended: boolean, color: string }>`
  &.membersTabWrapper{
    &.pureStorageMembers {
      .contentWrapperComponent {
        .dragDropdownContentWrapper {
          &.ant-popover {
            .ant-popover-inner {
              width: 195px;
            }
          }
        }
      }
    }
    display: grid;
    grid-template-rows: 46px; // for first row only
    grid-auto-rows: ${(props) => (props.isExpended ? '652px' : '336px')}; // for all upcoming rows & 4px increase in height so that gap can increase
    row-gap: 12px;
    padding-bottom: 200px;
    @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
      grid-template-rows: 38px;
      grid-auto-rows: ${(props) => (props.isExpended ? '520px' : '264px')}; // here using actual design dimensions
      row-gap: 8px;
    }
    @media all and (max-width: ${maxTablet}) {
      grid-template-rows: 36px;
      grid-auto-rows: ${(props) => (props.isExpended ? '498px' : '254px')}; // here using actual design dimensions
    }
    @media all and (max-width: ${maxMobile}){
      grid-auto-rows: ${(props) => (props.isExpended ? '520px' : '264px')}; // here using actual design dimensions
      overflow: auto;
    }
    .dragDropdown{
      display: flex;
    }
    .contentWrapperComponent{
      height: ${(props) => (props.isExpended ? '648px' : '332px')}; // to make it scrollable
      @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
        height: ${(props) => (props.isExpended ? '520px' : '264px')};
      }
      @media all and (max-width: ${maxTablet}) {
        height: ${(props) => (props.isExpended ? '498px' : '254px')};
      }
      @media all and (max-width: ${maxMobile}){
        height: ${(props) => (props.isExpended ? '508px' : '264px')};
      }
      position: ${(props) => (!props.isExpended && 'relative')};
      .dragDropdownContentWrapper {
        @media all and (max-width: ${maxMobile}){
          z-index: 2 !important;
        }
        &.ant-popover{
          overflow: hidden;
          border-radius: 8px;
          /* top: ${(props) => (!props.isExpended && '10px !important')}; */
          .ant-popover-inner{
            box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.12);
            border-radius: 8px;
            border: 1px solid #DADADA;
            background: ${white};
            width: 165px;
            padding: 0px;
            .ant-popover-inner-content{
              padding: 11px 8px 8px 8px;
              display: flex;
              flex-direction: column;
              width: 100%;
            }
          }
        }
        &.ant-popover-placement-bottom {
          padding-top: 0;
        }
        .popoverContent{
          display: flex;
          flex-direction: column;
          .header{
            display: flex;
            align-items: center;
            gap: 6px;
            margin-bottom: 6px;
            .avatarWrapper{
              padding: 2px;
              height: 22px;
              width: 22px;
              border-radius: 50%;
              display: flex;
              background: linear-gradient(to right, ${(props) => props.color}, ${(props) => props.color});
              .avatar{
                border-radius: 50%;
                height: 100%;
                width: 100%;
                object-fit: cover;
                border: 1px solid ${white};
              }
            }
            .actionText{
              color: ${primaryHeadingColor} !important;
              font-family: ${primaryFont};
              font-size: 16px;
              font-style: normal;
              font-weight: ${wMedium};
              line-height: 20px;
              letter-spacing: -0.4px;
              margin: 0;
            }
          }
          .radioGroupsWrapper{
            display: flex;
            flex-direction: column;
            gap: 12px;
            margin-bottom: 16px;
            .radioGroup{
              display: flex;
              flex-direction: column;
              gap: 4px;
              .radioGroupHeading{
                margin: 0;
                color: ${greyColorSecondary} !important;
                font-family: ${primaryFont};
                font-size: 12px;
                font-style: normal;
                font-weight: ${wMedium};
                line-height: 16px;
                letter-spacing: -0.4px;
              }
              .ant-radio-group{
                display: flex;
                flex-direction: column;
                gap: 6px;
                .ant-radio-wrapper{
                  display: flex;
                  align-items: center;
                  color: ${greyColor};
                  font-family: ${primaryFont};
                  font-size: 14px;
                  font-style: normal;
                  font-weight: ${wMedium};
                  line-height: 16.049px;
                  letter-spacing: -0.324px;
                  .ant-radio{
                    height: 16px;
                    width: 16px;
                    &.ant-radio-checked{
                      .ant-radio-inner{
                        &::after{
                          height: 16px;
                          width: 16px;
                          margin-left: -8px;
                          margin-top: -8px;
                          transform: scale(0.5);
                        }
                      }
                    }
                    .ant-radio-inner,
                    .ant-radio-input{
                      height: 16px;
                      width: 16px;
                    }
                    & + span{
                      padding-left: 6px !important;
                    }
                  }
                }
              }
            }
          }
          .buttonsWrapper{
            display: flex;
            align-items: center;
            gap: 6px;
            .move-group-button {
              border-radius: 100px;
              border: 2px solid ${primaryColor};
              font-family: ${primaryFont};
              font-weight: ${wMBold};
              text-align: center;
              font-size: 12px;
              line-height: 14px;
              white-space: pre;
              padding: 1.5px 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              flex: 1;
              cursor: pointer;
              &.move-button {
                color: #fff;
                background-color: ${primaryColor};
                &:disabled {
                  cursor: default;
                  opacity: 0.6;
                }
              }
              &.cancel-button {
                color:${primaryColor};
                background-color: #fff;
              }
            }
          }
        }
      }
    }
    .gridRow{
      display: grid;
      grid-template-columns: 42px 1fr;
      column-gap: 12px;
      margin-bottom: 4px; // to increase row-gap 12px to 16px
      @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
        grid-template-columns: 34px 1fr;
        column-gap: 8px;
        margin-bottom: 0;
      }
      &:first-child{
        margin: 0;
      }
      &.row1{
        position: sticky;
        top: 79px;
        z-index: 1;
        @media all and (max-width: ${maxTablet}){
          position: unset;
          z-index: 1;
        }
      }
      .headingCol{
        @media all and (max-width: ${maxMobile}){
          position: sticky;
          left: -1px;
          z-index: 1;
        }
      }
      .expandCollapseBtn{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        background-color: ${white};
        border-radius: 8px;
        cursor: pointer;
        @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
          border-radius: 7px;
        }
        .expandCollapsePopover{
          color: ${primaryHeadingColor};
          font-family: ${primaryFont};
          font-size: 14px;
          font-style: normal;
          font-weight: ${wMBold};
          line-height: 16px;
          letter-spacing: -0.4px;
          filter: drop-shadow(${boxShadow});
          @media (hover: none){
            display: none;
          }
          .ant-popover-inner{
            border-radius: 8px;
            max-width: 100px;
            height: 32px;
            white-space: nowrap;
            overflow: hidden;
            padding: 8px 10px 2px 10px !important;
          }
        }
        .iconWrapper{
          display: flex;
          padding: 15px 13px;
          @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
            padding: 12px 10px;
          }
          @media all and (max-width: ${maxTablet}) {
            padding: 11px 9px;
            max-height: 36px;
          }
          &:hover{
            svg{
              path{
                fill: ${primaryColor};
              }
            }
          }
          svg{
            height: 100%;
            width: 100%;
            display: inline-flex;
            &:hover{
              path{
              fill: ${primaryColor};
              }
            }
          }
        }
      }
      .contentWrapper{
        display: grid;
        grid-template-columns: repeat(3, minmax(300px, 1fr));
        column-gap: 24px;
        @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
          grid-template-columns: repeat(3, minmax(200px, 1fr));
          column-gap: 16px;
        }
        @media all and (max-width: ${maxTablet}) {
          grid-template-columns: repeat(3, minmax(200px, 1fr));
          column-gap: 10px;
        }
        @media all and (max-width: ${maxMobile}) {
          grid-template-columns: repeat(3, minmax(216px, 216px));
        }
        .contentBox{
          display: flex;
          .notEmployed {
            border-radius: 12px;
            background: #FAFFD1;
            max-height: 125px;
            @media all and (max-width: ${maxWidth}) , ${retina} {
              margin: 0px 1px;
            }
          }
        }
      }
    }
    .person-designation-tip{
      .ant-tooltip{
        font-size: 11px;
        @media screen and (max-width: ${minStandardScreen}) {
         font-size: 10px;
        }
        .ant-tooltip-content{
          .ant-tooltip-arrow{
            display: none !important;
          }
          .ant-tooltip-inner{
            max-width: 160px;
            box-shadow: 0 0 5px rgba(0,0,0,0.3);
            text-align: center;
            @media screen and (max-width: 1600px) {
              max-width: 140px;
            }
            @media screen and (max-width: ${minStandardScreen}) {
              padding: 8px;
            }
            @media screen and (max-width: ${midWidthApp}) {
              max-width: 120px;
              padding: 6px;
            }
          } 
        }
      }
    }
    .person-designation-tip,
    .messageIcon {
      .ant-tooltip{
        .ant-tooltip-content{
          .ant-tooltip-arrow{
            display: none !important;
          }
        }
      }
    }
  }
`;

const expandCollapsetoolTip = function expandCollapsetoolTip(text: string) {
  return (
    <div>
      {text}
    </div>
  );
};
type Props = {
  searchString?: string
  addRemovePerson?: (a: boolean, b: number, c: string, d: string) => void
  removedPeople?: number[]
  editEnable?: boolean
  isDrag: (a: boolean) => void
  filters?: string
  addReasonPopup: (a: PersonProps, b: string, c: string) => void
} & typeof defaultProps;

const defaultProps = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  addRemovePerson: (a: boolean, b: number, c: string, d: string) => { },
  removedPeople: [] as number[],
  editEnable: false,
  filters: '',
  searchString: '',
};

const MemberCategory = function (params: {
  person: Executive,
  editEnable: boolean,
  addRemovePerson?: (a: boolean, b: number, c: string, d: string) => void
  isDrag: (a: boolean) => void
  removedPeople?: number[],
  categoryData: ChangeCategoryData
  isBuyerGroupCard?: boolean
}) {
  const {
    person, editEnable, addRemovePerson, removedPeople, isDrag, categoryData, isBuyerGroupCard,
  } = params;
  return (
    <div key={person.personId} className={classNames('gutter-row d-flex justify-content-center tablet-scroll-col', { notEmployed: person.companyChangeFlag })}>
      {editEnable ? (
        <PeopleCardLarge
          noFollow
          showDrawerIcon={person.changed || !!person.personNotes}
          diameter="150px"
          diameterXxsm="100px"
          imageDiameter="60px"
          tagTextPadding="0px 20px"
          personName={person.personName}
          tag={person.personDesignation}
          hidePersonality={false}
          personaType={person.archeType.name}
          persona={person.archeType.color}
          personId={person.personId}
          wrapperColor={backgroundColorParsing(person?.personalityTypes)}
          personalityTypesColors={person?.personalityTypes}
          logo={person.personImage}
          addRemovePerson={addRemovePerson}
          company={person?.companyName}
          showCheckBox={editEnable}
          checked={removedPeople?.findIndex(
            (personId) => personId === person.personId,
          ) !== -1}
          showDropdownToDrag
          isExpended
          categoryData={categoryData}
          companyId={person?.companyId}
          location={person?.location}
        />
      )
        : (
          <DragWrapper key={person?.personId} isDrag={isDrag}>
            <PeopleCardLarge
              noFollow
              showDrawerIcon={person.changed || !!person.personNotes}
              membersActive
              imageDiameter="60px"
              tagTextPadding="0px 20px"
              personName={person.personName}
              tag={person.personDesignation}
              hidePersonality={false}
              personaType={person.archeType.name}
              persona={person.archeType.color}
              personId={person.personId}
              wrapperColor={backgroundColorParsing(person?.personalityTypes)}
              personalityTypesColors={person?.personalityTypes}
              logo={person.personImage}
              addRemovePerson={addRemovePerson}
              company={person?.companyName}
              showCheckBox={editEnable}
              checked={removedPeople?.findIndex(
                (personId) => personId === person.personId,
              ) !== -1}
              showDropdownToDrag
              isExpended
              categoryData={categoryData}
              companyId={person?.companyId}
              location={person?.location}
              isBuyerGroupCard
              showBlip={person?.blip || 0}
            />
          </DragWrapper>
        )}

    </div>
  );
};

const MembersTabV2 = function MembersTabV2(props: Props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    isDrag,
    addRemovePerson,
    addReasonPopup,
    removedPeople, editEnable, filters,
    searchString,
  } = props;

  const [isExpended, setIsExpended] = useState(false);

  const [searchParams] = useSearchParams();
  const groupId = searchParams.get('groupId');

  const groupIdParsed = groupId ? parseInt(groupId, 10) : 0;
  const dragGroupCategory = useSelector(selectGroupCategory);
  const membersPageNumber: number = useSelector(selectMembersPageNumber);
  const membersLoading: boolean = useSelector(selectMembersLoading);
  const membersInitialLoading: boolean = useSelector(selectMembersInitialLoading);
  // const membersEnded: boolean = useSelector(selectMembersEnded);
  const members: TopPeople | null = useSelector(selectMembers);
  const peopleRemoved: boolean = useSelector(selectPeopleRemovedFlag);
  const buyers = useSelector(selectBuyersCategory);
  const championBuyers = useSelector(selectChampionsCategory);
  const decisionMakers = useSelector(selectDecisionMakerCategory);
  const economicBuyers = useSelector(selectEconomicCategory);
  const technicalBuyers = useSelector(selectTechnicalCategory);
  const nonTechnicalLeaders = useSelector(selectNonTechnicalLeadersCategory);
  const technicalLeaders = useSelector(selectTechnicalLeadersCategory);
  const infrastructureLeaders = useSelector(selectInfrastructureCategory);
  const applicationOwners = useSelector(selectApplicationCategory);
  const securityOwners = useSelector(selectSecurityCategory);
  const previousSearchString = usePrevious(searchString);
  const tooltip = useSelector(selectBuyerTooltip);
  const dragPersonPersonality = useSelector(selectDragPersonPersonality);
  const disclessPersonality = useSelector(selectDisclessPersonality);
  const memberCategories = useSelector(selectMemberCategories);
  const memberCategoryLoading = useSelector(selectMemberCategoryLoading);
  const pureStorageFlag = useSelector(selectPureStorageFlag);
  // doers count
  const doersCount = !pureStorageFlag
    ? (buyers?.Doers?.membersCount || 0)
    + (championBuyers?.Doers?.membersCount || 0)
    + (decisionMakers?.Doers?.membersCount || 0)
    + (economicBuyers?.Doers?.membersCount || 0)
    + (technicalBuyers?.Doers?.membersCount || 0)
    : (buyers?.Doers?.membersCount || 0)
    + (nonTechnicalLeaders?.Doers?.membersCount || 0)
    + (technicalLeaders?.Doers?.membersCount || 0)
    + (infrastructureLeaders?.Doers?.membersCount || 0)
    + (applicationOwners?.Doers?.membersCount || 0)
    + (securityOwners?.Doers?.membersCount || 0);

  // coaches count
  const coachesCount = !pureStorageFlag
    ? (buyers?.Coaches?.membersCount || 0)
    + (championBuyers?.Coaches?.membersCount || 0)
    + (decisionMakers?.Coaches?.membersCount || 0)
    + (economicBuyers?.Coaches?.membersCount || 0)
    + (technicalBuyers?.Coaches?.membersCount || 0)
    : (buyers?.Coaches?.membersCount || 0)
    + (nonTechnicalLeaders?.Coaches?.membersCount || 0)
    + (technicalLeaders?.Coaches?.membersCount || 0)
    + (infrastructureLeaders?.Coaches?.membersCount || 0)
    + (applicationOwners?.Coaches?.membersCount || 0)
    + (securityOwners?.Coaches?.membersCount || 0);

  // blockers count
  const blockersCount = !pureStorageFlag
    ? (buyers?.Blockers?.membersCount || 0)
    + (championBuyers?.Blockers?.membersCount || 0)
    + (decisionMakers?.Blockers?.membersCount || 0)
    + (economicBuyers?.Blockers?.membersCount || 0)
    + (technicalBuyers?.Blockers?.membersCount || 0)
    : (buyers?.Blockers?.membersCount || 0)
    + (nonTechnicalLeaders?.Blockers?.membersCount || 0)
    + (technicalLeaders?.Blockers?.membersCount || 0)
    + (infrastructureLeaders?.Blockers?.membersCount || 0)
    + (applicationOwners?.Blockers?.membersCount || 0)
    + (securityOwners?.Blockers?.membersCount || 0);
  // buyers
  const buyersCount = (buyers?.Doers?.membersCount || 0) + (buyers?.Coaches?.membersCount || 0) + (buyers?.Blockers?.membersCount || 0);
  // champions
  const championsCount = (championBuyers?.Doers?.membersCount || 0) + (championBuyers?.Coaches?.membersCount || 0) + (championBuyers?.Blockers?.membersCount || 0);
  // decision makers
  const decisionMakerCount = (decisionMakers?.Doers?.membersCount || 0) + (decisionMakers?.Coaches?.membersCount || 0) + (decisionMakers?.Blockers?.membersCount || 0);
  // economic
  const economicCount = (economicBuyers?.Doers?.membersCount || 0) + (economicBuyers?.Coaches?.membersCount || 0) + (economicBuyers?.Blockers?.membersCount || 0);
  // technical buyers
  const technicalCount = (technicalBuyers?.Doers?.membersCount || 0) + (technicalBuyers?.Coaches?.membersCount || 0) + (technicalBuyers?.Blockers?.membersCount || 0);
  // non technical leaders count
  const nonTechinalLeadersCount = (nonTechnicalLeaders?.Blockers?.membersCount || 0) + (nonTechnicalLeaders?.Coaches?.membersCount || 0) + (nonTechnicalLeaders?.Doers?.membersCount || 0);
  // techinal leader count
  const technicalLeaderCount = (technicalLeaders?.Blockers?.membersCount || 0) + (technicalLeaders?.Coaches?.membersCount || 0) + (technicalLeaders?.Doers?.membersCount || 0);
  // infrastructure count
  const infrastructureCount = (infrastructureLeaders?.Blockers?.membersCount || 0) + (infrastructureLeaders?.Coaches?.membersCount || 0) + (infrastructureLeaders?.Doers?.membersCount || 0);
  // application count
  const applicationCount = (applicationOwners?.Blockers?.membersCount || 0) + (applicationOwners?.Coaches?.membersCount || 0) + (applicationOwners?.Doers?.membersCount || 0);
  // security count
  const securityCount = (securityOwners?.Blockers?.membersCount || 0) + (securityOwners?.Coaches?.membersCount || 0) + (securityOwners?.Doers?.membersCount || 0);
  useEffect(() => {
    if (groupIdParsed) {
      if (
        (
          searchString.length || (previousSearchString?.length && !searchString?.length)
        ) && previousSearchString !== searchString) {
        dispatch(actions.resetMembersPageNumber({}));
        dispatch(actions.getMembersV2({
          groupId: groupIdParsed,
          filterRequired: 1,
          offset: 0,
          ...filters?.length ? {
            filters,
          } : {},
          ...searchString.length ? {
            query: searchString,
          } : {},
        }));
      }
    } else navigate(-1);
  }, [searchString]);

  const fetchMoreMembers = (offset: number, category: string, stage: string) => {
    if (offset) {
      dispatch(actions.getMembersV2({
        groupId: groupIdParsed,
        filterRequired: 0,
        offset,
        stage,
        category,
        ...filters?.length ? {
          filters,
        } : {},
        ...searchString.length ? {
          query: searchString,
        } : {},
      }));
    }
  };

  const handleRemoveMembers = () => {
    (Object.keys(memberCategories) as Array<keyof MemberCategories>).forEach((category) => {
      (Object.keys(memberCategories[category]) as Array<keyof CategoryStages>).forEach((stage) => {
        const categoryStageData = memberCategories[category][stage];
        if (categoryStageData.persons.length < 8 && categoryStageData.membersCount > categoryStageData.persons.length) {
          fetchMoreMembers(categoryStageData.persons.length, camelCaseToNormal(category), stage);
        }
      });
    });
  };

  useEffect(() => {
    if (peopleRemoved) {
      handleRemoveMembers();
    }
  }, [peopleRemoved]);

  const exapandedViewHandler = () => {
    setIsExpended(true);
  };
  const collapseViewHandler = () => {
    setIsExpended(false);
  };

  const isLoading = (category: string, stage: string) => {
    if ((category === memberCategoryLoading?.category && stage === memberCategoryLoading?.stage) || membersInitialLoading) {
      return true;
    }
    return false;
  };

  return (
    <Wrapper
      color={disclessPersonality ? nutenixColor : backgroundColorParsing(dragPersonPersonality)}
      isExpended={isExpended}
      className={classNames('membersTabWrapper', {
        pureStorageMembers: pureStorageFlag,
      })}
      id="tabs-details members-tab-area"
    >
      <div className="gridRow row1">
        <div className="headingCol expandCollapseBtn">
          {
            isExpended ? (
              <Popover
                placement="right"
                content={expandCollapsetoolTip('Show Less')}
                overlayClassName="expandCollapsePopover"
                getPopupContainer={(e: HTMLElement) => e}
                arrow={false}
              >
                <span className="iconWrapper" onClick={collapseViewHandler}>
                  <CollapseIcon />
                </span>
              </Popover>
            ) : (
              <Popover
                placement="right"
                content={expandCollapsetoolTip('Show More')}
                overlayClassName="expandCollapsePopover"
                getPopupContainer={(e: HTMLElement) => e}
                arrow={false}
              >
                <span className="iconWrapper" onClick={exapandedViewHandler}>
                  <ExpandIcon />
                </span>
              </Popover>
            )
          }
        </div>
        <div className="contentWrapper">
          <div className="contentBox buyers-category">
            <GridHeadingBox toolTip={tooltip?.Doers} heading="Doers" count={doersCount} loading={membersInitialLoading} />
          </div>
          <div className="contentBox buyers-category">
            <GridHeadingBox toolTip={tooltip?.Coaches} heading="Coaches" count={coachesCount} loading={membersInitialLoading} />
          </div>
          <div className="contentBox buyers-category">
            <GridHeadingBox toolTip={tooltip?.Blockers} heading="Blockers" count={blockersCount} loading={membersInitialLoading} />
          </div>
        </div>
      </div>
      <div className="gridRow row2">
        <div className="headingCol">
          <GridHeadingBox isRowHeading heading="Buyers" count={buyersCount} />
        </div>
        <div className="contentWrapper">
          <div className="contentBox">
            <GridContentBox
              categoryData={{
                category: 'Buyers',
                stage: 'Doers',
                addReasonPopup,
              }}
              isEmpty={!membersInitialLoading && !buyers?.Doers?.persons?.length}
              scrollId="scroll-1"
            >
              <InfiniteScroll
                hasMore
                dataLength={buyers?.Doers?.persons?.length || 0}
                next={() => fetchMoreMembers(buyers?.Doers?.persons?.length, 'Buyers', 'Doers')}
                className=""
                loader={isLoading('Buyers', 'Doers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                scrollableTarget="scroll-1"
              >
                {buyers?.Doers?.persons.map((person) => (
                  <MemberCategory
                    person={person}
                    editEnable={editEnable}
                    addRemovePerson={addRemovePerson}
                    isDrag={isDrag}
                    removedPeople={removedPeople}
                    categoryData={{
                      prevCategory: buyers?.Doers?.category,
                      prevStage: buyers?.Doers?.stage,
                      addReasonPopup,
                    }}
                  />
                ))}
              </InfiniteScroll>
            </GridContentBox>
          </div>
          <div className="contentBox">
            <GridContentBox
              categoryData={{
                category: 'Buyers',
                stage: 'Coaches',
                addReasonPopup,
              }}
              isEmpty={!membersInitialLoading && !buyers?.Coaches?.persons?.length}
              scrollId="scroll-2"
            >
              <InfiniteScroll
                hasMore
                dataLength={buyers?.Coaches?.persons?.length || 0}
                next={() => fetchMoreMembers(buyers?.Coaches?.persons?.length, 'Buyers', 'Coaches')}
                className=""
                loader={isLoading('Buyers', 'Coaches') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                scrollableTarget="scroll-2"
              >
                {buyers?.Coaches?.persons.map((person) => (
                  <MemberCategory
                    person={person}
                    editEnable={editEnable}
                    addRemovePerson={addRemovePerson}
                    isDrag={isDrag}
                    removedPeople={removedPeople}
                    categoryData={{
                      prevCategory: buyers?.Coaches?.category,
                      prevStage: buyers?.Coaches?.stage,
                      addReasonPopup,
                    }}
                  />
                ))}
              </InfiniteScroll>
            </GridContentBox>
          </div>
          <div className="contentBox">
            <GridContentBox
              categoryData={{
                category: 'Buyers',
                stage: 'Blockers',
                addReasonPopup,
              }}
              isEmpty={!membersInitialLoading && !buyers?.Blockers?.persons?.length}
              scrollId="scroll-3"
            >
              <InfiniteScroll
                hasMore
                dataLength={buyers?.Blockers?.persons?.length || 0}
                next={() => fetchMoreMembers(buyers?.Blockers?.persons?.length, 'Buyers', 'Blockers')}
                className=""
                loader={isLoading('Buyers', 'Blockers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                scrollableTarget="scroll-3"
              >
                {buyers?.Blockers?.persons.map((person) => (
                  <MemberCategory
                    person={person}
                    editEnable={editEnable}
                    addRemovePerson={addRemovePerson}
                    isDrag={isDrag}
                    removedPeople={removedPeople}
                    categoryData={{
                      prevCategory: buyers?.Blockers?.category,
                      prevStage: buyers?.Blockers?.stage,
                      addReasonPopup,
                    }}
                  />
                ))}
              </InfiniteScroll>
            </GridContentBox>
          </div>
        </div>
      </div>
      {/* changes reflected from here */}
      {
        !pureStorageFlag ? (
          <>
            <div className="gridRow row3">
              <div className="headingCol">
                <GridHeadingBox
                  toolTipTextOnly="The Champion Buyer is an internal advocate with authority and influence within a prospect’s organization who supports your product or service."
                  isRowHeading
                  heading="Champion Buyers"
                  count={championsCount}
                />
              </div>
              <div className="contentWrapper">
                <div className="contentBox">
                  <GridContentBox
                    categoryData={{
                      category: 'Champion Buyers',
                      stage: 'Doers',
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !championBuyers?.Doers?.persons?.length}
                    scrollId="scroll-4"
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={championBuyers?.Doers?.persons?.length || 0}
                      next={() => fetchMoreMembers(championBuyers?.Doers?.persons?.length, 'Champion Buyers', 'Doers')}
                      className=""
                      loader={isLoading('Champion Buyers', 'Doers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-4"
                    >
                      {championBuyers?.Doers?.persons.map((person) => (
                        <MemberCategory
                          person={person}
                          editEnable={editEnable}
                          addRemovePerson={addRemovePerson}
                          isDrag={isDrag}
                          removedPeople={removedPeople}
                          categoryData={{
                            prevCategory: championBuyers?.Doers?.category,
                            prevStage: championBuyers?.Doers?.stage,
                            addReasonPopup,
                          }}
                        />
                      ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
                <div className="contentBox">
                  <GridContentBox
                    categoryData={{
                      category: 'Champion Buyers',
                      stage: 'Coaches',
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !championBuyers?.Coaches?.persons?.length}
                    scrollId="scroll-5"
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={championBuyers?.Coaches?.persons?.length || 0}
                      next={() => fetchMoreMembers(championBuyers?.Coaches?.persons?.length, 'Champion Buyers', 'Coaches')}
                      className=""
                      loader={isLoading('Champion Buyers', 'Coaches') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-5"
                    >
                      {championBuyers?.Coaches?.persons.map((person) => (
                        <MemberCategory
                          person={person}
                          editEnable={editEnable}
                          addRemovePerson={addRemovePerson}
                          isDrag={isDrag}
                          removedPeople={removedPeople}
                          categoryData={{
                            prevCategory: championBuyers?.Coaches?.category,
                            prevStage: championBuyers?.Coaches?.stage,
                            addReasonPopup,
                          }}
                        />
                      ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
                <div className="contentBox">
                  <GridContentBox
                    categoryData={{
                      category: 'Champion Buyers',
                      stage: 'Blockers',
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !championBuyers?.Blockers?.persons?.length}
                    scrollId="scroll-6"
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={championBuyers?.Blockers?.persons?.length || 0}
                      next={() => fetchMoreMembers(championBuyers?.Blockers?.persons?.length, 'Champion Buyers', 'Blockers')}
                      className=""
                      loader={isLoading('Champion Buyers', 'Blockers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-6"
                    >
                      {championBuyers?.Blockers?.persons.map((person) => (
                        <MemberCategory
                          person={person}
                          editEnable={editEnable}
                          addRemovePerson={addRemovePerson}
                          isDrag={isDrag}
                          removedPeople={removedPeople}
                          categoryData={{
                            prevCategory: championBuyers?.Blockers?.category,
                            prevStage: championBuyers?.Blockers?.stage,
                            addReasonPopup,
                          }}
                        />
                      ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
              </div>
            </div>
            <div className="gridRow row4">
              <div className="headingCol">
                <GridHeadingBox
                  toolTipTextOnly="The Decision Maker has the authority to make significant purchasing and investment decisions."
                  isRowHeading
                  heading="Decision Makers"
                  count={decisionMakerCount}
                />
              </div>
              <div className="contentWrapper">
                <div className="contentBox">
                  <GridContentBox
                    categoryData={{
                      category: 'Decision Makers',
                      stage: 'Doers',
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !decisionMakers?.Doers?.persons?.length}
                    scrollId="scroll-7"
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={decisionMakers?.Doers?.persons?.length || 0}
                      next={() => fetchMoreMembers(decisionMakers?.Doers?.persons?.length, 'Decision Makers', 'Doers')}
                      className=""
                      loader={isLoading('Decision Makers', 'Doers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-7"
                    >
                      {decisionMakers?.Doers?.persons.map((person) => (
                        <MemberCategory
                          person={person}
                          editEnable={editEnable}
                          addRemovePerson={addRemovePerson}
                          isDrag={isDrag}
                          removedPeople={removedPeople}
                          categoryData={{
                            prevCategory: decisionMakers?.Doers?.category,
                            prevStage: decisionMakers?.Doers?.stage,
                            addReasonPopup,
                          }}
                        />
                      ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
                <div className="contentBox">
                  <GridContentBox
                    categoryData={{
                      category: 'Decision Makers',
                      stage: 'Coaches',
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !decisionMakers?.Coaches?.persons?.length}
                    scrollId="scroll-8"
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={decisionMakers?.Coaches?.persons?.length || 0}
                      next={() => fetchMoreMembers(decisionMakers?.Coaches?.persons?.length, 'Decision Makers', 'Coaches')}
                      className=""
                      loader={isLoading('Decision Makers', 'Coaches') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-8"
                    >
                      {decisionMakers?.Coaches?.persons.map((person) => (
                        <MemberCategory
                          person={person}
                          editEnable={editEnable}
                          addRemovePerson={addRemovePerson}
                          isDrag={isDrag}
                          removedPeople={removedPeople}
                          categoryData={{
                            prevCategory: decisionMakers?.Coaches?.category,
                            prevStage: decisionMakers?.Coaches?.stage,
                            addReasonPopup,
                          }}
                        />
                      ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
                <div className="contentBox">
                  <GridContentBox
                    categoryData={{
                      category: 'Decision Makers',
                      stage: 'Blockers',
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !decisionMakers?.Blockers?.persons?.length}
                    scrollId="scroll-9"
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={decisionMakers?.Blockers?.persons?.length || 0}
                      next={() => fetchMoreMembers(decisionMakers?.Blockers?.persons?.length, 'Decision Makers', 'Blockers')}
                      className=""
                      loader={isLoading('Decision Makers', 'Blockers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-9"
                    >
                      {decisionMakers?.Blockers?.persons.map((person) => (
                        <MemberCategory
                          person={person}
                          editEnable={editEnable}
                          addRemovePerson={addRemovePerson}
                          isDrag={isDrag}
                          removedPeople={removedPeople}
                          categoryData={{
                            prevCategory: decisionMakers?.Blockers?.category,
                            prevStage: decisionMakers?.Blockers?.stage,
                            addReasonPopup,
                          }}
                        />
                      ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
              </div>
            </div>
            <div className="gridRow row5">
              <div className="headingCol">
                <GridHeadingBox
                  toolTipTextOnly="The Technical Buyer is a key decision-maker who focuses on the technical aspects of your product or service."
                  isRowHeading
                  heading="Technical Buyers"
                  count={technicalCount}
                />
              </div>
              <div className="contentWrapper">
                <div className="contentBox">
                  <GridContentBox
                    categoryData={{
                      category: 'Technical Buyers',
                      stage: 'Doers',
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !technicalBuyers?.Doers?.persons?.length}
                    scrollId="scroll-10"
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={technicalBuyers?.Doers?.persons?.length || 0}
                      next={() => fetchMoreMembers(technicalBuyers?.Doers?.persons?.length, 'Technical Buyers', 'Doers')}
                      className=""
                      loader={isLoading('Technical Buyers', 'Doers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-10"
                    >
                      {technicalBuyers?.Doers?.persons.map((person) => (
                        <MemberCategory
                          person={person}
                          editEnable={editEnable}
                          addRemovePerson={addRemovePerson}
                          isDrag={isDrag}
                          removedPeople={removedPeople}
                          categoryData={{
                            prevCategory: technicalBuyers?.Doers?.category,
                            prevStage: technicalBuyers?.Doers?.stage,
                            addReasonPopup,
                          }}
                        />
                      ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
                <div className="contentBox">
                  <GridContentBox
                    categoryData={{
                      category: 'Technical Buyers',
                      stage: 'Coaches',
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !technicalBuyers?.Coaches?.persons?.length}
                    scrollId="scroll-11"
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={technicalBuyers?.Coaches?.persons?.length || 0}
                      next={() => fetchMoreMembers(technicalBuyers?.Coaches?.persons?.length, 'Technical Buyers', 'Coaches')}
                      className=""
                      loader={isLoading('Technical Buyers', 'Coaches') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-11"
                    >
                      {technicalBuyers?.Coaches?.persons.map((person) => (
                        <MemberCategory
                          person={person}
                          editEnable={editEnable}
                          addRemovePerson={addRemovePerson}
                          isDrag={isDrag}
                          removedPeople={removedPeople}
                          categoryData={{
                            prevCategory: technicalBuyers?.Coaches?.category,
                            prevStage: technicalBuyers?.Coaches?.stage,
                            addReasonPopup,
                          }}
                        />
                      ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
                <div className="contentBox">
                  <GridContentBox
                    categoryData={{
                      category: 'Technical Buyers',
                      stage: 'Blockers',
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !technicalBuyers?.Blockers?.persons?.length}
                    scrollId="scroll-12"
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={technicalBuyers?.Blockers?.persons?.length || 0}
                      next={() => fetchMoreMembers(technicalBuyers?.Blockers?.persons?.length, 'Technical Buyers', 'Blockers')}
                      className=""
                      loader={isLoading('Technical Buyers', 'Blockers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-12"
                    >
                      {technicalBuyers?.Blockers?.persons.map((person) => (
                        <MemberCategory
                          person={person}
                          editEnable={editEnable}
                          addRemovePerson={addRemovePerson}
                          isDrag={isDrag}
                          removedPeople={removedPeople}
                          categoryData={{
                            prevCategory: technicalBuyers?.Blockers?.category,
                            prevStage: technicalBuyers?.Blockers?.stage,
                            addReasonPopup,
                          }}
                        />
                      ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
              </div>
            </div>
            <div className="gridRow row6">
              <div className="headingCol">
                <GridHeadingBox
                  toolTipTextOnly="The Economic Buyer determines whether the investment required makes the most financial sense."
                  isRowHeading
                  heading="Economic Buyers"
                  count={economicCount}
                />
              </div>
              <div className="contentWrapper">
                <div className="contentBox">
                  <GridContentBox
                    categoryData={{
                      category: 'Economic Buyers',
                      stage: 'Doers',
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !economicBuyers?.Doers?.persons?.length}
                    scrollId="scroll-13"
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={economicBuyers?.Doers?.persons?.length || 0}
                      next={() => fetchMoreMembers(economicBuyers?.Doers?.persons?.length, 'Economic Buyers', 'Doers')}
                      className=""
                      loader={isLoading('Economic Buyers', 'Doers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-13"
                    >
                      {economicBuyers?.Doers?.persons.map((person) => (
                        <MemberCategory
                          person={person}
                          editEnable={editEnable}
                          addRemovePerson={addRemovePerson}
                          isDrag={isDrag}
                          removedPeople={removedPeople}
                          categoryData={{
                            prevCategory: economicBuyers?.Doers?.category,
                            prevStage: economicBuyers?.Doers?.stage,
                            addReasonPopup,
                          }}
                        />
                      ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
                <div className="contentBox">
                  <GridContentBox
                    categoryData={{
                      category: 'Economic Buyers',
                      stage: 'Coaches',
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !economicBuyers?.Coaches?.persons?.length}
                    scrollId="scroll-14"
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={economicBuyers?.Coaches?.persons?.length || 0}
                      next={() => fetchMoreMembers(economicBuyers?.Coaches?.persons?.length, 'Economic Buyers', 'Coaches')}
                      className=""
                      loader={isLoading('Economic Buyers', 'Coaches') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-14"
                    >
                      {economicBuyers?.Coaches?.persons.map((person) => (
                        <MemberCategory
                          person={person}
                          editEnable={editEnable}
                          addRemovePerson={addRemovePerson}
                          isDrag={isDrag}
                          removedPeople={removedPeople}
                          categoryData={{
                            prevCategory: economicBuyers?.Coaches?.category,
                            prevStage: economicBuyers?.Coaches?.stage,
                            addReasonPopup,
                          }}
                        />
                      ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
                <div className="contentBox">
                  <GridContentBox
                    categoryData={{
                      category: 'Economic Buyers',
                      stage: 'Blockers',
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !economicBuyers?.Blockers?.persons?.length}
                    scrollId="scroll-15"
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={economicBuyers?.Blockers?.persons?.length || 0}
                      next={() => fetchMoreMembers(economicBuyers?.Blockers?.persons?.length, 'Economic Buyers', 'Blockers')}
                      className=""
                      loader={isLoading('Economic Buyers', 'Blockers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-15"
                    >
                      {economicBuyers?.Blockers?.persons.map((person) => (
                        <MemberCategory
                          person={person}
                          editEnable={editEnable}
                          addRemovePerson={addRemovePerson}
                          isDrag={isDrag}
                          removedPeople={removedPeople}
                          categoryData={{
                            prevCategory: economicBuyers?.Blockers?.category,
                            prevStage: economicBuyers?.Blockers?.stage,
                            addReasonPopup,
                          }}
                        />
                      ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className='gridRow row3'>
              <div className="headingCol">
                <GridHeadingBox isRowHeading heading="Non-technical Leaders" count={nonTechinalLeadersCount} toolTipTextOnly='This group oversees strategic business health, finances, and ensures technology investments are cost-efficient, compliant, and sustainable.' />
              </div>
              <div className='contentWrapper'>
                <div className='contentBox'>
                  <GridContentBox
                    categoryData={{
                      category: 'Non-technical Leaders',
                      stage: 'Doers',
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !nonTechnicalLeaders?.Doers?.persons?.length}
                    scrollId='scroll-4'
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={nonTechnicalLeaders?.Doers?.persons?.length || 0}
                      next={() => fetchMoreMembers(nonTechnicalLeaders?.Doers?.persons?.length, "Non-technical Leaders", "Doers")}
                      className=''
                      loader={isLoading('Non-technical Leaders', 'Doers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-4"
                    >
                      {nonTechnicalLeaders?.Doers?.persons?.map((person) => (
                        <MemberCategory
                          person={person}
                          editEnable={editEnable}
                          addRemovePerson={addRemovePerson}
                          isDrag={isDrag}
                          removedPeople={removedPeople}
                          categoryData={{
                            prevCategory: nonTechnicalLeaders?.Doers?.category,
                            prevStage: nonTechnicalLeaders?.Doers?.stage,
                            addReasonPopup
                          }}
                        />
                      ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
                <div className='contentBox'>
                  <GridContentBox
                    categoryData={{
                      category: "Non-technical Leaders",
                      stage: "Coaches",
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !nonTechnicalLeaders?.Coaches?.persons?.length}
                    scrollId="scroll-5"
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={nonTechnicalLeaders?.Coaches?.persons?.length || 0}
                      next={() => fetchMoreMembers(nonTechnicalLeaders?.Coaches?.persons?.length, "Non-technical Leaders", "Coaches")}
                      className=''
                      loader={isLoading('Non-technical Leaders', 'Coaches') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-5"
                    >
                      {nonTechnicalLeaders?.Coaches?.persons?.map((person) => (
                        <MemberCategory
                          person={person}
                          editEnable={editEnable}
                          addRemovePerson={addRemovePerson}
                          isDrag={isDrag}
                          removedPeople={removedPeople}
                          categoryData={{
                            prevCategory: nonTechnicalLeaders?.Coaches?.category,
                            prevStage: nonTechnicalLeaders?.Coaches?.stage,
                            addReasonPopup
                          }}
                        />
                      ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
                <div className='contentBox'>
                  <GridContentBox
                    categoryData={{
                      category: "Non-technical Leaders",
                      stage: "Blockers",
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !nonTechnicalLeaders?.Blockers?.persons?.length}
                    scrollId='scroll-6'
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={nonTechnicalLeaders?.Blockers?.persons?.length || 0}
                      next={() => fetchMoreMembers(nonTechnicalLeaders?.Blockers?.persons?.length, "Non-technical Leaders", "Blockers")}
                      className=''
                      loader={isLoading('Non-technical Leaders', 'Blockers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-6"
                    >
                      {nonTechnicalLeaders?.Blockers?.persons?.map((person) => (
                        <MemberCategory
                          person={person}
                          editEnable={editEnable}
                          addRemovePerson={addRemovePerson}
                          isDrag={isDrag}
                          removedPeople={removedPeople}
                          categoryData={{
                            prevCategory: nonTechnicalLeaders?.Blockers?.category,
                            prevStage: nonTechnicalLeaders?.Blockers?.stage,
                            addReasonPopup
                          }}
                        />
                      ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>

              </div>
            </div>
            <div className='gridRow row4'>
              <div className='headingCol'>
                <GridHeadingBox
                  isRowHeading
                  heading='Technical Leaders'
                  toolTipTextOnly='This group holds primary buying authority for infrastructure and storage, defining strategy and making final purchasing decisions.'
                  count={technicalLeaderCount}
                />
              </div>
              <div className='contentWrapper'>
                <div className='contentBox'>
                  <GridContentBox
                    categoryData={{
                      category: 'Technical Leaders',
                      stage: 'Doers',
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !technicalLeaders?.Doers?.persons?.length}
                    scrollId='scroll-7'
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={technicalLeaders?.Doers?.persons?.length || 0}
                      next={() => fetchMoreMembers(technicalLeaders?.Doers?.persons?.length, "Technical Leaders", "Doers")}
                      className=''
                      loader={isLoading('Technical Leaders', 'Doers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-7"
                    >
                      {
                        technicalLeaders?.Doers?.persons.map((person) => (
                          <MemberCategory
                            person={person}
                            editEnable={editEnable}
                            addRemovePerson={addRemovePerson}
                            isDrag={isDrag}
                            removedPeople={removedPeople}
                            categoryData={{
                              prevCategory: technicalLeaders?.Doers?.category,
                              prevStage: technicalLeaders?.Doers?.stage,
                              addReasonPopup,
                            }}
                          />
                        ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
                <div className='contentBox'>
                  <GridContentBox
                    categoryData={{
                      category: "Technical Leaders",
                      stage: "Coaches",
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !technicalLeaders?.Coaches?.persons?.length}
                    scrollId="scroll-8"
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={technicalLeaders?.Coaches?.persons?.length || 0}
                      next={() => fetchMoreMembers(technicalLeaders?.Coaches?.persons?.length, "Technical Leaders", "Coaches")}
                      className=''
                      loader={isLoading('Technical Leaders', 'Coaches') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-8"
                    >
                      {
                        technicalLeaders?.Coaches?.persons.map((person) => (
                          <MemberCategory
                            person={person}
                            editEnable={editEnable}
                            addRemovePerson={addRemovePerson}
                            isDrag={isDrag}
                            removedPeople={removedPeople}
                            categoryData={{
                              prevCategory: technicalLeaders?.Coaches?.category,
                              prevStage: technicalLeaders?.Coaches?.stage,
                              addReasonPopup,
                            }}
                          />
                        ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
                <div className='contentBox'>
                  <GridContentBox
                    categoryData={{
                      category: "Technical Leaders",
                      stage: "Blockers",
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !technicalLeaders?.Blockers?.persons?.length}
                    scrollId='scroll-9'
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={technicalLeaders?.Blockers?.persons?.length || 0}
                      next={() => fetchMoreMembers(technicalLeaders?.Blockers?.persons?.length, "Technical Leaders", "Blockers")}
                      className=''
                      loader={isLoading('Technical Leaders', 'Blockers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-9"
                    >
                      {
                        technicalLeaders?.Blockers?.persons.map((person) => (
                          <MemberCategory
                            person={person}
                            editEnable={editEnable}
                            addRemovePerson={addRemovePerson}
                            isDrag={isDrag}
                            removedPeople={removedPeople}
                            categoryData={{
                              prevCategory: technicalLeaders?.Blockers?.category,
                              prevStage: technicalLeaders?.Blockers?.stage,
                              addReasonPopup,
                            }}
                          />
                        ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>

              </div>

            </div>
            <div className='gridRow row5'>
              <div className='headingCol'>
                <GridHeadingBox
                  isRowHeading
                  heading='Infrastructure & Technicals'
                  toolTipTextOnly='This group manages daily infrastructure and storage operations, influencing technical evaluations, prioritizing performance, security, and data protection.'
                  count={infrastructureCount}
                />
              </div>
              <div className='contentWrapper'>
                <div className='contentBox'>
                  <GridContentBox
                    categoryData={{
                      category: 'Infrastructure & Technicals',
                      stage: 'Doers',
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !infrastructureLeaders?.Doers?.persons?.length}
                    scrollId='scroll-10'
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={infrastructureLeaders?.Doers?.persons?.length || 0}
                      next={() => fetchMoreMembers(infrastructureLeaders?.Doers?.persons?.length, "Infrastructure & Technicals", "Doers")}
                      className=''
                      loader={isLoading('Infrastructure & Technicals', 'Doers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-10"
                    >
                      {
                        infrastructureLeaders?.Doers?.persons.map((person) => (
                          <MemberCategory
                            person={person}
                            editEnable={editEnable}
                            addRemovePerson={addRemovePerson}
                            isDrag={isDrag}
                            removedPeople={removedPeople}
                            categoryData={{
                              prevCategory: infrastructureLeaders?.Doers?.category,
                              prevStage: infrastructureLeaders?.Doers?.stage,
                              addReasonPopup,
                            }}
                          />
                        ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
                <div className='contentBox'>
                  <GridContentBox
                    categoryData={{
                      category: "Infrastructure & Technicals",
                      stage: "Coaches",
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !infrastructureLeaders?.Coaches?.persons?.length}
                    scrollId="scroll-11"
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={infrastructureLeaders?.Coaches?.persons?.length || 0}
                      next={() => fetchMoreMembers(infrastructureLeaders?.Coaches?.persons?.length, "Infrastructure & Technicals", "Coaches")}
                      className=''
                      loader={isLoading('Infrastructure & Technicals', 'Coaches') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-11"
                    >
                      {
                        infrastructureLeaders?.Coaches?.persons.map((person) => (
                          <MemberCategory
                            person={person}
                            editEnable={editEnable}
                            addRemovePerson={addRemovePerson}
                            isDrag={isDrag}
                            removedPeople={removedPeople}
                            categoryData={{
                              prevCategory: infrastructureLeaders?.Coaches?.category,
                              prevStage: infrastructureLeaders?.Coaches?.stage,
                              addReasonPopup,
                            }}
                          />
                        ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
                <div className='contentBox'>
                  <GridContentBox
                    categoryData={{
                      category: "Infrastructure & Technicals",
                      stage: "Blockers",
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !infrastructureLeaders?.Blockers?.persons?.length}
                    scrollId='scroll-12'
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={infrastructureLeaders?.Blockers?.persons?.length || 0}
                      next={() => fetchMoreMembers(infrastructureLeaders?.Blockers?.persons?.length, "Infrastructure & Technicals", "Blockers")}
                      className=''
                      loader={isLoading('Infrastructure & Technicals', 'Blockers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-12"
                    >
                      {
                        infrastructureLeaders?.Blockers?.persons.map((person) => (
                          <MemberCategory
                            person={person}
                            editEnable={editEnable}
                            addRemovePerson={addRemovePerson}
                            isDrag={isDrag}
                            removedPeople={removedPeople}
                            categoryData={{
                              prevCategory: infrastructureLeaders?.Blockers?.category,
                              prevStage: infrastructureLeaders?.Blockers?.stage,
                              addReasonPopup,
                            }}
                          />
                        ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
              </div>
            </div>
            <div className='gridRow row6'>
              <div className='headingCol'>
                <GridHeadingBox
                  isRowHeading
                  heading='Application Owners'
                  toolTipTextOnly='This group defines application-specific infrastructure requirements, evaluates providers, and prioritizes performance, SLAs, security, and data protection.'
                  count={applicationCount}
                />
              </div>
              <div className='contentWrapper'>
                <div className='contentBox'>
                  <GridContentBox
                    categoryData={{
                      category: 'Application Owners',
                      stage: 'Doers',
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !applicationOwners?.Doers?.persons?.length}
                    scrollId='scroll-13'
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={applicationOwners?.Doers?.persons?.length || 0}
                      next={() => fetchMoreMembers(applicationOwners?.Doers?.persons?.length, "Application Owners", "Doers")}
                      className=''
                      loader={isLoading('Application Owners', 'Doers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-13"
                    >
                      {
                        applicationOwners?.Doers?.persons.map((person) => (
                          <MemberCategory
                            person={person}
                            editEnable={editEnable}
                            addRemovePerson={addRemovePerson}
                            isDrag={isDrag}
                            removedPeople={removedPeople}
                            categoryData={{
                              prevCategory: applicationOwners?.Doers?.category,
                              prevStage: applicationOwners?.Doers?.stage,
                              addReasonPopup,
                            }}
                          />
                        ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
                <div className='contentBox'>
                  <GridContentBox
                    categoryData={{
                      category: "Application Owners",
                      stage: "Coaches",
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !applicationOwners?.Coaches?.persons?.length}
                    scrollId="scroll-14"
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={applicationOwners?.Coaches?.persons?.length || 0}
                      next={() => fetchMoreMembers(applicationOwners?.Coaches?.persons?.length, "Application Owners", "Coaches")}
                      className=''
                      loader={isLoading('Application Owners', 'Coaches') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-14"
                    >
                      {
                        applicationOwners?.Coaches?.persons.map((person) => (
                          <MemberCategory
                            person={person}
                            editEnable={editEnable}
                            addRemovePerson={addRemovePerson}
                            isDrag={isDrag}
                            removedPeople={removedPeople}
                            categoryData={{
                              prevCategory: applicationOwners?.Coaches?.category,
                              prevStage: applicationOwners?.Coaches?.stage,
                              addReasonPopup,
                            }}
                          />
                        ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
                <div className='contentBox'>
                  <GridContentBox
                    categoryData={{
                      category: "Application Owners",
                      stage: "Blockers",
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !applicationOwners?.Blockers?.persons?.length}
                    scrollId='scroll-15'
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={applicationOwners?.Blockers?.persons?.length || 0}
                      next={() => fetchMoreMembers(applicationOwners?.Blockers?.persons?.length, "Application Owners", "Blockers")}
                      className=''
                      loader={isLoading('Application Owners', 'Blockers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-15"
                    >
                      {
                        applicationOwners?.Blockers?.persons.map((person) => (
                          <MemberCategory
                            person={person}
                            editEnable={editEnable}
                            addRemovePerson={addRemovePerson}
                            isDrag={isDrag}
                            removedPeople={removedPeople}
                            categoryData={{
                              prevCategory: applicationOwners?.Blockers?.category,
                              prevStage: applicationOwners?.Blockers?.stage,
                              addReasonPopup,
                            }}
                          />
                        ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
              </div>

            </div>
            <div className='gridRow row7'>
              <div className='headingCol'>
                <GridHeadingBox
                  isRowHeading
                  heading='Security Owners'
                  toolTipTextOnly='This group provides security oversight with veto power, managing risk and ensuring compliance as a crucial gatekeeper for technology solutions.'
                  count={securityCount}
                />
              </div>
              <div className='contentWrapper'>
                <div className='contentBox'>
                  <GridContentBox
                    categoryData={{
                      category: 'Security Owners',
                      stage: 'Doers',
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !securityOwners?.Doers?.persons?.length}
                    scrollId='scroll-16'
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={securityOwners?.Doers?.persons?.length || 0}
                      next={() => fetchMoreMembers(securityOwners?.Doers?.persons?.length, "Security Owners", "Doers")}
                      className=''
                      loader={isLoading('Security Owners', 'Doers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-16"
                    >
                      {
                        securityOwners?.Doers?.persons.map((person) => (
                          <MemberCategory
                            person={person}
                            editEnable={editEnable}
                            addRemovePerson={addRemovePerson}
                            isDrag={isDrag}
                            removedPeople={removedPeople}
                            categoryData={{
                              prevCategory: securityOwners?.Doers?.category,
                              prevStage: securityOwners?.Doers?.stage,
                              addReasonPopup,
                            }}
                          />
                        ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
                <div className='contentBox'>
                  <GridContentBox
                    categoryData={{
                      category: "Security Owners",
                      stage: "Coaches",
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !securityOwners?.Coaches?.persons?.length}
                    scrollId="scroll-17"
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={securityOwners?.Coaches?.persons?.length || 0}
                      next={() => fetchMoreMembers(securityOwners?.Coaches?.persons?.length, "Security Owners", "Coaches")}
                      className=''
                      loader={isLoading('Security Owners', 'Coaches') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-17"
                    >
                      {
                        securityOwners?.Coaches?.persons.map((person) => (
                          <MemberCategory
                            person={person}
                            editEnable={editEnable}
                            addRemovePerson={addRemovePerson}
                            isDrag={isDrag}
                            removedPeople={removedPeople}
                            categoryData={{
                              prevCategory: securityOwners?.Coaches?.category,
                              prevStage: securityOwners?.Coaches?.stage,
                              addReasonPopup,
                            }}
                          />
                        ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
                <div className='contentBox'>
                  <GridContentBox
                    categoryData={{
                      category: "Security Owners",
                      stage: "Blockers",
                      addReasonPopup,
                    }}
                    isEmpty={!membersInitialLoading && !securityOwners?.Blockers?.persons?.length}
                    scrollId='scroll-18'
                  >
                    <InfiniteScroll
                      hasMore
                      dataLength={securityOwners?.Blockers?.persons?.length || 0}
                      next={() => fetchMoreMembers(securityOwners?.Blockers?.persons?.length, "Security Owners", "Blockers")}
                      className=''
                      loader={isLoading('Security Owners', 'Blockers') && [1, 2, 3, 4].map(() => <PersonSkeleton hideBtn diameterSm="60px" diameter="60px" />)}
                      scrollableTarget="scroll-13"
                    >
                      {
                        securityOwners?.Blockers?.persons.map((person) => (
                          <MemberCategory
                            person={person}
                            editEnable={editEnable}
                            addRemovePerson={addRemovePerson}
                            isDrag={isDrag}
                            removedPeople={removedPeople}
                            categoryData={{
                              prevCategory: securityOwners?.Blockers?.category,
                              prevStage: securityOwners?.Blockers?.stage,
                              addReasonPopup,
                            }}
                          />
                        ))}
                    </InfiniteScroll>
                  </GridContentBox>
                </div>
              </div>

            </div>
          </>
        )
      }
    </Wrapper>
  );
};

export default MembersTabV2;
